export default __webpack_public_path__ + "static/media/c-back-top-icon.55aefe13.png";